import React, { useState } from "react";
import { Select, Switch, Tabs } from "antd";
import images from "../../themes/appImage";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumb, Modal } from "antd";
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";
import { DatePicker, Space } from "antd";
import { TimePicker } from "antd";
import { Collapse } from "antd";
import Dashboard from "../Organizations/charts/Dashboard";
import Flag from "react-country-flag";
import UserTable from "./userTabel";
import MyinnerCirle from "../myinnerCircle";
import Admin from "./admin/Admin";
import Who from "./admin/WHO/Who";
import { imageURL } from "../../redux/Api/apikit";
import Departments from "./departments";

const { Option } = Select;

const countryOptions = [
  { code: "US", label: "United States" },
  { code: "CA", label: "Canada" },
  { code: "GB", label: "United Kingdom" },
];

const onChange2 = (time, timeString) => {
  console.log(time, timeString);
};

// switch
const onChange3 = (checked) => {
  console.log(`switch to ${checked}`);
};

const handleChange = (value) => {
  console.log(`selected ${value}`);
};

const onChange = (date, dateString) => {
  console.log(date, dateString);
};

const { Panel } = Collapse;

const OrganizationsSummary = () => {
  const { state } = useLocation();

  const [modal1Open, setModal1Open] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const [modal3Open, setModal3Open] = useState(false);
  const [modal4Open, setModal4Open] = useState(false);
  const [modal5Open, setModal5Open] = useState(false);
  const [modal6Open, setModal6Open] = useState(false);
  const [modal7Open, setModal7Open] = useState(false);
  const [modal8Open, setModal8Open] = useState(false);

  return (
    <div>
      <div className="site-layout-background" style={{ minHeight: 360 }}>
        <div className="top-header-organi-zations">
          <div className="organi-zations-heading-text">
            <h1>Organizations</h1>
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <Link to="/organizations"> Organizations </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{state?.name}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>

        <div className="content">
          <section>
            <div className="university_hading_layout">
              <div className="univer_flex-section">
                <div className="university_top_right-_side">
                  <div className="university_logo">
                    <img
                      src={`${imageURL}${state.image}`}
                      className="w-16 h-16 object-contain rounded-full"
                      alt="universityLogo"
                    />
                  </div>
                  <div className="university_heading">
                    <h1>{state.name}</h1>
                    <div className="email-and-plans">
                      <p>
                        <span>
                          <img src={images.emailIcons} alt="emailIcons" />
                        </span>
                        {state.email}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="update-btn-right"></div>
              </div>
            </div>
          </section>

          <section>
            <div className="slider-section">
              <div className="slider-tab-div">
                <div className="tab-bar">
                  <Tabs>
                    <Tabs.TabPane tab="Summary" key="1">
                      <Dashboard myid={state.id} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="User" key="2">
                      <UserTable myid={state.id} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Department" key="3">
                      <Departments myid={state.id} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Inner Circle" key="4">
                      <MyinnerCirle myid={state.id} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="WHO5 Assessment" key="5">
                      <Who myid={state.id} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Settings" key="6">
                      <Admin myid={state.id} />
                    </Tabs.TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal2Open}
        closable={true}
        // onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Add Users</h1>
          </div>

          <div className="click-to-upload">
            <div className="upload-file">
              <img src={images.fileImg} alt="back" />
              <div>
                <button>Click here to upload</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* create inner circle */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal1Open}
        closable={true}
        onCancel={() => setModal1Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Create Inner Circle</h1>
          </div>

          <div className="description-inner-circle">
            <div className="wrapper_line">
              <div className="form-group">
                <label>{appconstant.name}</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter Inner circle name "
                />
              </div>

              <div className="form-group">
                <div className="textarea-label">
                  <label>{appconstant.description}</label>
                  <p>0/500</p>
                </div>
                <textarea
                  rows="5"
                  cols="50"
                  className="form-control-textarea"
                  type="textarea"
                  placeholder="Enter Description"
                />
              </div>
            </div>
          </div>

          <div className="click-to-upload">
            <div className="create-inner-circle-btn">
              <button>Create Inner Circle</button>
            </div>
          </div>
        </div>
      </Modal>

      {/* create activity */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal3Open}
        closable={true}
        onCancel={() => setModal3Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Create Custom Activity</h1>
          </div>

          <div className="description-inner-circle">
            <div className="wrapper_line">
              <div className="form-group">
                <label>{appconstant.addTitle}</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter Activity Title "
                />
              </div>

              <div className="date-and-time ">
                <div className="select-date form-group">
                  <div className="textarea-label">
                    <label>{appconstant.selectDate}</label>
                  </div>
                  <Space direction="vertical">
                    <DatePicker placeholder="Date" onChange={onChange} />
                  </Space>
                </div>

                <div className="select-date form-group">
                  <div className="textarea-label">
                    <label>{appconstant.selectTime}</label>
                  </div>
                  {/* <TimePicker placeholder="Time" onChange={onChange2} defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')} /> */}
                  <TimePicker placeholder="Time" onChange={onChange2} />
                </div>
              </div>

              <div className="form-group">
                <div className="textarea-label">
                  <label>{appconstant.description}</label>
                  <p>0/500</p>
                </div>
                <textarea
                  rows="5"
                  cols="50"
                  className="form-control-textarea"
                  type="textarea"
                  placeholder="Enter Description"
                />
              </div>
            </div>
          </div>

          <div className="click-to-upload">
            <div className="create-inner-circle-btn">
              <button>Create</button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Request Assessment */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal4Open}
        closable={true}
        onCancel={() => setModal4Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Request Assessment</h1>
          </div>

          <div className="schedule-send-now">
            <div className="btn-schedule send-now">
              <button
                onClick={() => {
                  setModal4Open(false);
                  setModal5Open(true);
                }}
              >
                {" "}
                Schedule
              </button>
            </div>

            <div className="btn-schedule ">
              <button>Send Now</button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Schedule WHO5 Assessment */}
      <Modal
        title=""
        className="modal-update"
        centered
        open={modal5Open}
        closable={true}
        onCancel={() => setModal5Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Schedule WHO5 Assessment</h1>
          </div>

          <div className="description-inner-circle">
            <div className="who-five">
              <div className="date-and-time ">
                <div className="select-date form-group">
                  <div className="textarea-label label-text">
                    <label>{appconstant.selectDate}</label>
                  </div>
                  <Space direction="vertical">
                    <DatePicker placeholder="Date" onChange={onChange} />
                  </Space>
                </div>

                <div className="select-date form-group ">
                  <div className="textarea-label label-text">
                    <label>{appconstant.selectTime}</label>
                  </div>
                  {/* <TimePicker placeholder="Time" onChange={onChange2} defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')} /> */}
                  <TimePicker placeholder="Time" onChange={onChange2} />
                </div>
              </div>
            </div>
          </div>

          <div className="click-to-upload">
            <div className="create-inner-circle-btn less-margin-top">
              <button
                onClick={() => {
                  setModal5Open(false);
                  setModal6Open(true);
                }}
              >
                Schedule
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Scheduled WHO5 Assessment edit */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal6Open}
        closable={true}
        onCancel={() => setModal6Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Schedule WHO5 Assessment</h1>
          </div>

          <div className="description-inner-circle">
            <div className="who-five">
              <div className="scheduled-timing">
                <p>
                  Upcoming Assessment Date:{" "}
                  <span> October 24, 2019 | 10:00PM </span>{" "}
                </p>
              </div>
            </div>
          </div>

          <div className="click-to-upload">
            <div className="create-inner-circle-btn less-margin-inner">
              <button
                onClick={() => {
                  setModal6Open(false);
                  setModal5Open(true);
                }}
              >
                Edit Schedule
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Add New Admin */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal7Open}
        closable={true}
        onCancel={() => setModal7Open(false)}
        footer={false}
        width={400}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Add New Admin</h1>
          </div>

          <div className="description-inner-circle">
            <div className="">
              <div className="form-group">
                <label>{appconstant.name}</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter your name "
                />
              </div>

              <div className="form-group">
                <label>{appconstant.email}</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter your email "
                />
              </div>

              <div className="form-group">
                <label>{appconstant.password}</label>
                <Textfiled
                  className="form-control"
                  type="password"
                  placeholder="Enter your pssword "
                />
              </div>
            </div>
          </div>

          <div className="click-to-upload">
            <div className=" create-admin">
              <button
                onClick={() => {
                  setModal7Open(false);
                }}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Add New Organization */}
      <Modal
        title=""
        className="modal-update new-organization "
        centered
        visible={modal8Open}
        closable={true}
        onCancel={() => setModal8Open(false)}
        footer={false}
        width={800}
      >
        <div className="add-user-popup">
          <div className="modal-add-user new-organi-zation-title">
            <h1>Add New Organization</h1>
          </div>
          <div className="create-org-detail">
            <div className="orgn-plans">
              <div className="logo-upload">
                <img src={images.uploadLogo} alt="uploadLogo" />
                <p>Upload Logo</p>
              </div>

              <div className="modal-right-side">
                <div className="form-group">
                  <label>{appconstant.organizationName}</label>
                  <Textfiled
                    className="form-control"
                    type="text"
                    placeholder="Enter Inner circle name "
                  />
                </div>

                <div className="date-and-time ">
                  <div className="form-group">
                    <label>{appconstant.email}</label>
                    <Textfiled
                      className="form-control"
                      type="text"
                      placeholder="Enter your email "
                    />
                  </div>

                  <div className="form-group flag-box">
                    <label>{appconstant.phone}</label>
                    <Textfiled
                      className="form-control country-flag-box"
                      type="text"
                      placeholder="Enter Inner circle name "
                    />
                    <div className="country-flag">
                      <Select
                        style={{ width: 200 }}
                        dropdownRender={(menu) => <div>{menu}</div>}
                      >
                        {countryOptions.map((country) => (
                          <Option key={country.code} value={country.code}>
                            <Flag
                              countryCode={country.code}
                              svg
                              style={{ marginRight: 8 }}
                            />
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="date-and-time ">
                  <div className="select-date form-group">
                    <div className="textarea-label">
                      <label>{appconstant.startDate}</label>
                    </div>
                    <Space direction="vertical">
                      <DatePicker placeholder="Date" onChange={onChange} />
                    </Space>
                  </div>

                  <div className="select-date form-group">
                    <div className="textarea-label">
                      <label>{appconstant.expiryDate}</label>
                    </div>
                    <Space direction="vertical">
                      <DatePicker placeholder="Date" onChange={onChange} />
                    </Space>
                  </div>
                </div>

                <div className=" plan-check-box">
                  <div className="textarea-label">
                    <label>{appconstant.plan}</label>
                  </div>
                  <Select
                    defaultValue="Select Plan"
                    onChange={handleChange}
                    options={[
                      { value: "one", label: "Premium" },
                      { value: "two", label: "Pro" },
                      { value: "three", label: "Ultimate" },
                    ]}
                  />
                </div>

                <div className="app-features">
                  <h1>App Features</h1>
                  <div className="enable-btn">
                    <div className="switch-btn">
                      <Switch defaultChecked onChange={onChange3} />
                      <p>Log Mood</p>
                    </div>

                    <div className="switch-btn">
                      <Switch defaultChecked onChange={onChange3} />
                      <p>Log Thoughts</p>
                    </div>

                    <div className="switch-btn">
                      <Switch defaultChecked onChange={onChange3} />
                      <p>Affirmations</p>
                    </div>

                    <div className="switch-btn">
                      <Switch defaultChecked onChange={onChange3} />
                      <p>Journal</p>
                    </div>

                    <div className="switch-btn">
                      <Switch defaultChecked onChange={onChange3} />
                      <p>Meditation</p>
                    </div>
                    <div className="switch-btn">
                      <Switch defaultChecked onChange={onChange3} />
                      <p>Therapy</p>
                    </div>
                    <div className="switch-btn">
                      <Switch defaultChecked onChange={onChange3} />
                      <p>Playlists</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="click-to-upload top-border-line">
            <div className="create-inner-circle-btn button-spacing">
              <button>Create Organization</button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default OrganizationsSummary;
